/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var Ladda = require('ladda');

var modelGet = require('common/util/modelGet');
var BreadcrumbView = require('common/views/BreadcrumbView');
var LicenseHeaderBarView = require('../../common/views/LicenseHeaderBarView');

var SubmitLicenseBond = require('../services/SubmitLicenseBond');
var LicenseBondFormView = require('../../new-license/views/LicenseBondFormView');
var tmplNonDepNewLicenseBondView = require('../templates/NonDepNewLicenseBondView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepNewLicenseBondView,

  className: 'non-dep-new-license-bond-view container-fluid',

  ui: {
    headerBarContainer: '.header-bar-container',
    breadCrumbContainer: '.breadcrumb-container',
    nonDepNewlicenseBondViewContainer: '.non-dep-new-license-bond-view-container',
    submitButton: '.submit-button'
  },

  regions: {
    headerBarContainer: '@ui.headerBarContainer',
    breadCrumbContainer: '@ui.breadCrumbContainer',
    nonDepNewlicenseBondViewContainer: '@ui.nonDepNewlicenseBondViewContainer'
  },

  events: {
    'click @ui.submitButton': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId');
    var licenseId = this.model.get('licenseId');
    var licenseType = modelGet(this.model, 'licenseIdentifiers.licenseType');
    var licenseNumber = modelGet(this.model, 'licenseIdentifiers.licenseNumber');
    var entityName = modelGet(this.model, 'licenseIdentifiers.entityName');

    this.showChildView(
      'headerBarContainer',
      new LicenseHeaderBarView({
        model: new Backbone.Model(this.model.get('licenseIdentifiers'))
      })
    );

    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#nondep/dashboard'
          },
          {
            text: entityName,
            link: '#nondep/entity/' + entityId + '/dashboard'
          },
          {
            text: 'License #' + licenseNumber + ' - ' + licenseType,
            link: '#nondep/entity/' + entityId + '/license/' + licenseId
          },
          {
            text: 'Add Bond'
          }
        ]
      })
    );

    this.licenseBondFormView = new LicenseBondFormView({
      viewMode: 'adHocEdit',
      model: this.model
    });

    this.showChildView('nonDepNewlicenseBondViewContainer', this.licenseBondFormView);
  },

  onClickSubmit: function(event) {
    event.preventDefault();
    var self = this;
    var bondId = modelGet(self.model, 'bond.bondId');
    var bond = self.getFormData();
    bond.isDeleted = '0';
    this.validate().done(function() {
      var appData = {
        entityId: self.model.get('entityId'),
        licenseId: self.model.get('licenseId'),
        bondId: bondId,
        bond: bond
      };
      var laddaContext = Ladda.create(self.ui.submitButton.get(0));
      laddaContext.start();
      SubmitLicenseBond(appData)
        .done(function(response) {
          Radio.channel('navigate').trigger(
            'show:int:nd:license-dashboard',
            self.model.get('entityId'),
            self.model.get('licenseId')
          );
        })
        .fail(function(err) {
          laddaContext.stop();
        });
    });
  },

  validate: function() {
    var config = {};
    return this.licenseBondFormView.validate(config);
  },

  getFormData: function() {
    var formData = this.licenseBondFormView.getFormData();
    formData.id = this.model.get('id');
    return formData;
  }
});
